var App = App || {};

App.Commerce = (function ($, ko) {
	"use strict";

	function Cart(data) {
		data = data || {};
		this.totalQuantity = ko.observable(Number(data.totalQuantity || 0));
		this.totalPrice = ko.observable(String(data.totalPrice || ""));
		this.subtotal = ko.observable(String(data.subtotal || ""));
		this.tax = ko.observable(String(data.tax || ""));
		this.discountApplied = ko.observable(String(data.discountApplied || ""));
		this.shipping = ko.observable(String(data.shipping || ""));
		this.includeShipping = ko.observable(!!data.includeShipping);
		this.includeTax = ko.observable(!!data.includeTax);
		this.orderLines = ko.observableArray(Array.isArray(data.orderLines) ? data.orderLines : []);
		this.couponCodes = ko.observableArray(Array.isArray(data.couponCodes) ? data.couponCodes : []);
	}

	function Coupon(cartObs) {
		this.code = ko.observable("");
		this.isChecking = ko.observable(false);
		this.isBusy = ko.observable(false);
		this.isValid = ko.observable(false);
		this.message = ko.observable("");
		this._xhr = null;

		this.appliedCodes = ko.pureComputed(function () {
			var cart = cartObs();
			return cart ? cart.couponCodes() : [];
		});

		function listHasCode(list, codeText) {
			return (Array.isArray(list) ? list : []).
				some((code) => String(code).toLowerCase() === String(codeText || "").toLowerCase());
		}

		function setCheckingState(isOn) {
			$("#coupon-code")
				.closest(".field-wrapper")
				.toggleClass("is-checking", !!isOn);
		}

		function setValidityMessage(message) {
			var $input = $("#coupon-code");
			$input[0].setCustomValidity(message || "");
			var hasError = !!message;
			$input.attr("aria-invalid", String(hasError)).toggleClass("is-invalid", hasError);
			$input.closest(".field-wrapper").find(".field-validation-error").text(message || "");
		}

		this.code.extend({ rateLimit: { timeout: 400, method: "notifyWhenChangesStop" } })
			.subscribe(function (currentValue) {
				var inputCode = (currentValue || "").trim();

				if (this._xhr) {
					this._xhr.abort();
					this._xhr = null;
				}

				this.isValid(false);
				this.message("");
				setValidityMessage("");
				setCheckingState(false);

				if (!inputCode) return;

				if (listHasCode(this.appliedCodes(), inputCode)) {
					this.isValid(true);
					return;
				}

				this.isChecking(true);
				setCheckingState(true);

				var requestToken = inputCode;
				this._xhr = $.ajax({
					url: "/api/cart/coupons/validate/" + encodeURIComponent(inputCode),
					contentType: "application/json; charset=utf-8",
					method: "GET",
					dataType: "json"
				}).done(function (response) {
					if (requestToken !== (this.code() || "").trim())
						return;

					if (!response || !response.status) {
						this.isValid(false)
						this.message("Invalid or expired code.");
						return;
					}

					this.isValid(response.status === "Success");
					this.message(this.isValid() ? "" : (response.message || "Invalid or expired code."));
					setValidityMessage(this.isValid() ? "" : this.message());
				}.bind(this)).fail(function () {
					if (requestToken !== (this.code() || "").trim()) return;
					this.isValid(false);
					this.message("Unable to validate code right now.");
					setValidityMessage(this.message());
				}.bind(this)).always(function () {
					if (requestToken === (this.code() || "").trim()) {
						this._xhr = null;
						this.isChecking(false);
						setCheckingState(false);
					}
				}.bind(this));
			}, this);

		this.canApply = ko.pureComputed(function () {
			var code = (this.code() || "").trim();
			if (!code)
				return false;

			if (this.isBusy() || this.isChecking())
				return false;

			if (listHasCode(this.appliedCodes(), code))
				return false;

			return this.isValid();
		}, this);

		this.apply = function () {
			var code = (this.code() || "").trim();
			if (!code || this.isBusy() || this.isChecking())
				return;

			this.isBusy(true);
			$.ajax({
				url: "/api/cart/coupons/apply",
				contentType: "application/json; charset=utf-8",
				method: "POST",
				data: JSON.stringify({ code: code }),
				dataType: "json"
			}).done(function (response) {
				if (response && response.message)
					App.Base.ShowInformation(response.message);

				RefreshCartData();
				this.code("");
				this.isValid(false);
				setValidityMessage("");
			}.bind(this)).fail(function () {
				App.Base.ShowError("Unable to apply coupon code. Please try again.");
			}).always(function () {
				this.isBusy(false);
			}.bind(this));
		}.bind(this);

		this.remove = function (code) {
			if (!code || this.isBusy()) return;

			this.isBusy(true);
			$.ajax({
				url: "/api/cart/coupons/remove",
				contentType: "application/json; charset=utf-8",
				method: "POST",
				data: JSON.stringify({ code: code }),
				dataType: "json"
			}).done(function (response) {
				if (response && response.message) App.Base.ShowInformation(response.message);
				RefreshCartData();
				if ((this.code() || "").trim().toLowerCase() === String(code).toLowerCase()) {
					this.isValid(false);
					setValidityMessage("");
				}
			}.bind(this)).fail(function () {
				App.Base.ShowError("Unable to remove coupon code. Please try again.");
			}).always(function () {
				this.isBusy(false);
			}.bind(this));
		}.bind(this);

		this.onKeyDown = function (_, e) {
			if (e && e.key === "Enter") {
				e.preventDefault();
				if (this.canApply()) this.apply();
			}
			return true;
		}.bind(this);
	}

	var viewModel = {
		cart: ko.observable(new Cart({}))
	};

	viewModel.coupon = new Coupon(viewModel.cart);

	function EditSeat(data, event) {
		var editModal = document.getElementById("event-registration-edit"),
			bsEditModal = new bootstrap.Offcanvas(editModal),
			editContainer = document.getElementById("event-registration-edit-container");

		bsEditModal.show();
		ko.cleanNode(editContainer);
		ko.applyBindings(data, editContainer);

		$(bsEditModal).one("hide.bs.offcanvas", function () {
			ko.cleanNode(editContainer);
		});
	}

	function SetSeat(data, event) {
		data.userData.cartDescription = "Attending: " + (data.userData && data.userData.seat ? data.userData.seat.name : "");
		var payload = {
			orderLineId: data.id,
			propertyName: "userData",
			data: data.userData
		};
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/set_property/",
			contentType: "application/json; charset=utf-8",
			method: "POST",
			data: JSON.stringify(payload),
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));

			App.Base.ShowInformation(response.message);
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function Add(product, productVariant, quantity, userData) {
		var payload = { product: product, productVariant: productVariant, quantity: quantity, userData: userData };
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/add",
			contentType: "application/json; charset=utf-8",
			method: "POST",
			data: JSON.stringify(payload),
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));

			App.Base.ShowInformation(response.message);
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function Bundle(product, productVariant, quantity, bundleItems, userData) {
		var payload = { product: product, productVariant: productVariant, quantity: quantity, BundleItems: bundleItems, userData: userData };
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/bundle",
			contentType: "application/json; charset=utf-8",
			method: "POST",
			data: JSON.stringify(payload),
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));

			App.Base.ShowInformation(response.message);
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function SetQuantity(orderLineId, quantity) {
		var payload = { orderLineId: orderLineId, quantity: quantity };
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/set_quantity",
			contentType: "application/json; charset=utf-8",
			method: "POST",
			data: JSON.stringify(payload),
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));

			App.Base.ShowInformation(response.message);
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function Remove(orderLineId) {
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/remove?orderLineId=" + encodeURIComponent(orderLineId),
			contentType: "application/json; charset=utf-8",
			method: "GET",
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));

			App.Base.ShowInformation(response.message);
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function RefreshCartData() {
		var token = $('meta[name="request-verification-token"]').attr('content');
		return $.ajax({
			url: "/api/cart/refresh",
			contentType: "application/json; charset=utf-8",
			method: "GET",
			headers: { 'RequestVerificationToken': token },
			dataType: "json"
		}).done(function (response) {
			if (response.orderSummary)
				viewModel.cart(new Cart(response.orderSummary));
		}).fail(function () {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function init() {
		ko.bindingHandlers.stopBinding = {
			init: function () {
				return {
					controlsDescendantBindings: true
				};
			}
		};

		RefreshCartData();

		$(".cart-data").each(function () {
			ko.applyBindings(viewModel, this);
		});

		$(document)
			.off("change", ".cart-data .item-quantity")
			.on("change", ".cart-data .item-quantity", function () {
				SetQuantity($(this).data("id"), Number($(this).val()) || 1);
			});

		$(document)
			.off("click", ".cart-data .item-remove")
			.on("click", ".cart-data .item-remove", function () {
				Remove($(this).data("id"));
			});
	}

	return {
		init: init,
		Add: Add,
		Bundle: Bundle,
		EditSeat: EditSeat,
		SetSeat: SetSeat,
		RefreshCartData: RefreshCartData,
		viewModel: viewModel
	};

})(jQuery, ko);

$(function () {
	App.Commerce.init();
});